
import { Box } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { dateAccesor } from "../../commons/table/columns/accesors";
import { dateChipWithStatus } from "../../commons/table/columns/cells";
import {
  tableConfig
} from "../../commons/table/config/tableConfig";
import TitleContainer from "../../commons/table/utilsTable/titleWithFetchData";

const ServiceMonitorTable = ({
  data,
  loading,
}) => {
  const columns = [
    {
      header: "ART",
      accessorKey: "nombreArt",
      Cell: ({ row }) => {
        return row.original.nombreArt.toUpperCase()
      },
      enableColumnFilter: false,
    },
    {
      header: "Procesamiento XML",
      accessorKey: "fechaProcesamientoXML",
      accessorFn: dateAccesor("fechaProcesamientoXML"),
      filterFn: "includesString",
      Cell: dateChipWithStatus('N/A', true, "small"),
    },
    {
      header: "Procesamiento Temporales",
      accessorKey: "fechaProcesamientoTemporales",
      accessorFn: dateAccesor("fechaProcesamientoTemporales"),
      filterFn: "includesString",
      Cell: dateChipWithStatus('N/A', true, "small"),
    },
    {
      header: "Consumo Novedades",
      accessorKey: "fechaConsumoNovedades",
      accessorFn: dateAccesor("fechaConsumoNovedades"),
      filterFn: "includesString",
      Cell: dateChipWithStatus('N/A', true, "small"),
    },
    {
      header: "Respuesta Prestadores",
      accessorKey: "fechaRespuestasPrestadores",
      accessorFn: dateAccesor("fechaRespuestasPrestadores"),
      filterFn: "includesString",
      Cell: dateChipWithStatus('N/A', true, "small"),
    },
    {
      header: "Respuesta FPA",
      accessorKey: "fechaRespuestaFPA",
      accessorFn: dateAccesor("fechaRespuestaFPA"),
      filterFn: "includesString",
      Cell: dateChipWithStatus('N/A', true, "small"),
    },
    {
      header: "Consumo Procesos",
      accessorKey: "fechaConsumoProcesos",
      accessorFn: dateAccesor("fechaConsumoProcesos"),
      filterFn: "includesString",
      Cell: dateChipWithStatus('N/A', true, "small"),
    },
  ];

  return (
    <div >
      <MaterialReactTable
        {...tableConfig}
        positionToolbarAlertBanner="top"
        columns={columns}
        defaultColumn={{
          maxSize: 80,
          minSize: 20,
          size: 20,
          muiFilterTextFieldProps: {
            placeholder: '',
          },
        }}
        renderTopToolbarCustomActions={() => (
          <Box m={0.5}>
            <TitleContainer
              title="Monitor de Servicios"
            />
          </Box>
        )}
        data={data}
        state={{ isLoading: loading }}
        layoutMode="grid"
      />
    </div>
  );
};

export default ServiceMonitorTable;